import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import backgroundImage from "../../assets/images/BG1.jpg";
import logoImage from "../../assets/images/Red-Rhino-Logo.png";
import { validateUsername } from "../../utils/validationUtils";
import { useRole } from "../../context/RoleContext";
import { fetchCustomersByEmail } from "../../api/customerAPI";
import { AuthApiService } from "../../service/authService";
import { fetchUsersByEmail } from "../../api/userAPI";
import { getUserEmailFromLocalStorage } from "../../utils/localStorageUtils";
import { styles } from "./LoginScreen.styles";
import useIsMobile from "../../common/mobileVersion/useIsMobile";

const LoginScreen: React.FC = () => {
  const [username, setUsername] = useState<string>(
    () => localStorage.getItem("rememberedUsername") || ""
  );
  const [password, setPassword] = useState<string>("");
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const isMobile = useIsMobile();
  const orgId = localStorage.getItem("orgId");

  useEffect(() => {
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    if (rememberedUsername) {
      setUsername(rememberedUsername);
    }
  }, []);

  const navigate = useNavigate();
  const { setRole } = useRole(); // Access the role context

  const handleLogin = async () => {
    const storedOrgId = localStorage.getItem("orgId");
    console.log("store Org id", storedOrgId);

    if (!storedOrgId) {
      alert("Organization ID is missing. Please check the URL.");
      return;
    }
    const usernameError = validateUsername(username);
    const passwordError = password.length === 0;

    if (usernameError) {
      alert(usernameError);
      return;
    }

    if (passwordError) {
      alert("Pleaase enter your password.");
      return;
    }
    if (!orgId) {
      alert("Organization ID is missing. Please check the URL.");
      console.error("Organization ID is missing while trying to loggin!");
      return;
    }

    try {
      const response = await AuthApiService.login(username, password);
      const userGroup = await AuthApiService.getUserGroups(response.idToken);
      const userRole = userGroup[0] ?? ""; // Use default value if `role` is undefined
      setRole(userRole.toLocaleLowerCase());

      localStorage.setItem("userEmail", username.toLowerCase());

      if (rememberMe) {
        localStorage.setItem("rememberedUsername", username); // Persist email
      } else {
        localStorage.removeItem("rememberedUsername"); // Remove if unchecked
      }
      const userEmail = getUserEmailFromLocalStorage();
      if (userRole.toLocaleLowerCase() === "customer" && userEmail) {
        const response = await fetchCustomersByEmail({ emailId: userEmail });
        const customerName = response.customer.outletName;
        localStorage.setItem("Name", customerName);
        navigate(`/${orgId}/customer/home`);
      } else if (userRole.toLocaleLowerCase() === "seller") {
        const response = await fetchUsersByEmail({
          emailId: userEmail as string,
        });
        const sellerName = response.data.data.seller.name;
        localStorage.setItem("Name", sellerName);
        navigate(`/${orgId}/seller/create-new-customer`);
      } else {
        alert("Role not recognized.");
      }
    } catch (error: any) {
      if (error.errCode === "UserNotFoundException") {
        alert(error?.message || "Login failed. Please try again.");
      } else if (error.errCode === "NotAuthorizedException") {
        alert(error?.message || "Login failed. Please try again.");
      } else if (error.errCode == "UserNotConfirmedException") {
        alert(error?.message || "Login failed. Please try again.");
      } else {
        console.log(error);
        alert("An error occurred. Please try again later.");
      }
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const rememberedUsername = localStorage.getItem("rememberedUsername");
    const orgId = localStorage.getItem("orgId");
    localStorage.clear();
    if (orgId) {
      localStorage.setItem("orgId", orgId);
    }
    if (rememberedUsername) {
      localStorage.setItem("rememberedUsername", rememberedUsername);
    }
  }, []);

  return (
    <Box sx={styles.container(backgroundImage)}>
      <Box sx={styles.logoContainer(isMobile)}>
        <Box
          component="img"
          src={logoImage}
          alt="Logo"
          sx={styles.logo(isMobile)}
        />
      </Box>
      <Box sx={styles.formContainer(isMobile)}>
        <Typography variant="h2" sx={styles.heading(isMobile)}>
          Welcome Back
        </Typography>

        <Box>
          <Typography variant="body2" sx={styles.label(isMobile)}>
            User Name
          </Typography>
          <TextField
            placeholder="username@test.com"
            fullWidth
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={styles.textField}
          />
        </Box>

        <Box>
          <Typography variant="body2" sx={styles.label(isMobile)}>
            Password
          </Typography>
          <TextField
            placeholder="password@123"
            type={showPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={styles.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={togglePasswordVisibility}
                    sx={styles.iconButton}
                    data-testid="toggle-visibility"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box sx={styles.rememberMeContainer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                sx={styles.checkbox}
              />
            }
            label={
              <Typography variant="body2" sx={styles.rememberMeLabel(isMobile)}>
                Remember me on this computer
              </Typography>
            }
          />
          <Link
            to={`/${orgId}/forgotPassword`}
            style={styles.forgotPassword(isMobile)}
          >
            Forgot Pɑssword?
          </Link>
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLogin}
          sx={styles.loginButton(isMobile)}
        >
          LOG IN
        </Button>
      </Box>
    </Box>
  );
};
export default LoginScreen;
